/**
 * A CAIXA "ABASTECE EM POSTO PARCEIRO" (0133, decisao 59).
 *
 * Pedido do dono (30/10/2026): "nos veiculos da frota coloque uma opcao de
 * selecao se esse veiculo vai aparecer na lista de equipamentos dos postos
 * parceiros ou nao". E caixa de selecao, e nao chave (p.24): a chave tem
 * efeito imediato, e aqui o valor so vale quando a ficha e gravada, com o
 * resto. Mora num componente so porque o cadastro e a edicao da ficha a usam,
 * e a frase que explica a consequencia tem de ser a mesma nos dois.
 */
export function CaixaAbasteceEmPosto({
  id,
  marcada,
  aoMudar,
}: {
  readonly id: string;
  readonly marcada: boolean;
  readonly aoMudar: (marcada: boolean) => void;
}) {
  return (
    <label htmlFor={id} className="campo-linha flex cursor-pointer items-start gap-3">
      <input
        id={id}
        type="checkbox"
        className="mt-1 size-4 shrink-0 accent-[var(--acao-primaria)]"
        checked={marcada}
        onChange={(evento) => {
          aoMudar(evento.target.checked);
        }}
      />
      <span className="flex flex-col gap-1">
        <span className="txt-rotulo-campo">Abastece em posto parceiro</span>
        <span className="txt-ajuda">
          Marcada, a máquina entra na lista do posto parceiro e ele lança o abastecimento dela. Desmarcada, o posto não
          a vê e o sistema recusa o lançamento dele nesta máquina. A empresa continua lançando em qualquer uma.
        </span>
      </span>
    </label>
  );
}
